<div class="spinner">
    <mat-spinner color="accent"></mat-spinner>
    <span *ngIf="text">{{text | translate}}</span>
</div>